/* eslint-disable camelcase */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import Button from '@material-ui/core/Button';
import { useSelector } from 'react-redux';

// import modalActions from '../../redux/actions/modals';

import { CalendarTodayOutlined, RoomOutlined } from '@material-ui/icons';
import cls from './style.module.scss';

import EventHelper from '../../helpers/Event';
import UserHelper from '../../helpers/User';
import OfferBoxPricing from './components/OfferBoxPricing';
import LinkInternal from './components/LinkComponent';

function OfferBox({
  target,
  event,
  addIvitation,
  onStep5,
  getSlugEvent,
  getJoinEvent,
  sizeBox,
  forMap,
  fullScreen,
  hidePlaces,
  hidePrices,
  showFullTitle,
  noLink,
  url,
  limitUser,
}) {
  const { t } = useTranslation();
  const eventHelper = new EventHelper(event);
  if (limitUser) {
    eventHelper.setUserLimitation(limitUser);
  }
  const arrayAmpty = new Array(
    3 - eventHelper.getCaptainAvatars().length,
  ).fill();
  const user = useSelector((state) => state.authentication.user);

  const newCls = cls;

  let baseClass = newCls.offerBox_wrapper;

  if (sizeBox) {
    baseClass = cls.sizeBox;
  }

  if (forMap) {
    baseClass = cls.forMap;
  }

  if (fullScreen) {
    baseClass = `${baseClass} ${cls.full_screen}`;
  }

  if (showFullTitle) {
    baseClass = `${baseClass} ${cls.full_title}`;
  }

  if (noLink) {
    baseClass = `${baseClass} ${cls.no_link}`;
  }

  if (hidePlaces) {
    baseClass = `${baseClass} ${cls.no_places}`;
  }

  // eslint-disable-next-line camelcase
  let { search_offer_box } = newCls;

  if (event.isPriority) {
    search_offer_box = `${search_offer_box} ${cls.is_priority}`;
  }

  let eventLink = `/event/${event && event.slug}`;
  if (url) {
    eventLink = `/event/${event && event.slug}?${url}`;
  }

  let LinkComponent = Link;

  if (noLink) {
    LinkComponent = LinkInternal;
  }

  return (
    <div className={baseClass} title={eventHelper.getTitle()}>
      <div className={search_offer_box}>
        <LinkComponent to={eventLink} target={target} className={newCls.unlink}>
          {/* {event.groupedEvents.length === 0 && ( */}
          <div className={newCls.offer_img}>
            <LazyLoad height={200}>
              <picture>
                <source
                  srcSet={eventHelper.getMainImage('618_360_crop', 'webp')}
                  type="image/webp"
                />
                <source srcSet={eventHelper.getMainImage()} type="image/jpeg" />
                <img
                  src={eventHelper.getMainImage()}
                  alt={eventHelper.getTitle()}
                />
              </picture>
            </LazyLoad>
            <div className={newCls.img_onTop}>
              {!event.isHideDates && (
                <div className={newCls.img_onTop_wrap}>
                  <CalendarTodayOutlined />
                  {!eventHelper.isLikeRentWithCaptain() ? (
                    <>
                      <span>{eventHelper.getStartDate('DD.MM.YYYY -')}</span>
                      <span>{eventHelper.getFinishDate(' DD.MM.YYYY')}</span>
                      {event.groupedEvents.length > 0 ? (
                        <span className={newCls.moreDates}>
                          ({t('event.moreDates').toLowerCase()})
                        </span>
                      ) : (
                        ''
                      )}
                    </>
                  ) : (
                    <span> {t('offerBox.regular')}</span>
                  )}
                </div>
              )}
              {eventHelper.getLocationStartName() && (
                <div className={newCls.img_onTop_wrap}>
                  <RoomOutlined />
                  <span>{eventHelper.getLocationStartName()}</span>
                </div>
              )}
            </div>
          </div>
          <div className={cls.blockTitle}>
            <h3>{event && event.title}</h3>
            <p
              className={cls.shortDesc}
              title={eventHelper.getShortDescription()}
            >
              {eventHelper.getShortDescription()}
            </p>
          </div>
          {!hidePrices && <OfferBoxPricing eventHelper={eventHelper} />}
        </LinkComponent>

        {!hidePlaces &&
          (eventHelper.getPlacesCount() > 0 ? (
            <div className={newCls.offer_description}>
              <div className={newCls.offer_team}>
                <div className={newCls.offer_team_people}>
                  {!eventHelper.checkEventPublic(user) &&
                    !event.isTheoreticCourses &&
                    arrayAmpty.map((el, index) => (
                      <Link
                        key={index}
                        to={`/create-event/yacht?slug=${event.slug}&user=${user.slug}`}
                        className={newCls.unlink}
                      >
                        <div className={newCls.empty_avatar}>
                          {index === arrayAmpty.length - 1 && <span>+</span>}
                        </div>
                      </Link>
                    ))}
                  {eventHelper.getCaptainAvatars().map((ava, key) => {
                    const userHelper = new UserHelper({
                      avatar: ava,
                    });
                    return (
                      <Link
                        key={key}
                        to={`${eventLink}`}
                        target="_blank"
                        title={ava.name}
                        className={newCls.unlink}
                        onClick={() => {
                          localStorage.setItem('link_user', ava.user);
                        }}
                      >
                        <LazyLoad>
                          <picture>
                            <source
                              srcSet={userHelper.getAvatar(
                                '80_80_crop',
                                'webp',
                              )}
                              type="image/webp"
                            />
                            <source
                              srcSet={userHelper.getAvatar('80_80_crop')}
                              type="image/jpeg"
                            />
                            <img
                              src={userHelper.getAvatar('80_80_crop')}
                              alt={ava.name}
                            />
                          </picture>
                        </LazyLoad>
                      </Link>
                    );
                  })}
                </div>
                <div className={newCls.offer_team_desc}>
                  {true ? ( // todo logic
                    <LinkComponent
                      to={eventLink}
                      target={target}
                      className={newCls.unlink}
                    >
                      <p className={newCls.offer_team_desc_amount}>
                        {t('offerBox.placesIn')} {eventHelper.getCaptainCount()}
                        {t(
                          `offerBox.${
                            eventHelper.getCaptainCount() > 1
                              ? 'teams'
                              : 'teams1'
                          }`,
                        )}
                      </p>
                    </LinkComponent>
                  ) : (
                    <p>
                      {t('offerBox.noPlaces')}
                      <Button variant="outlined">
                        {t('offerBox.request')}
                      </Button>
                    </p>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className={newCls.offer_description}>
              <div className={newCls.offer_team}>
                <div className={newCls.offer_team_people}>
                  <LinkComponent
                    to={eventLink}
                    target={target}
                    className={newCls.unlink}
                  >
                    <div className={newCls.empty_avatar_not_offer}>
                      <LazyLoad>
                        <picture className={cls.hovered}>
                          <source
                            srcSet="https://media.insailing.com/images/offersByRequest.webp"
                            type="image/webp"
                          />
                          <source
                            srcSet="https://media.insailing.com/images/offersByRequest.jpg"
                            type="image/jpeg"
                          />
                          <img
                            src="https://media.insailing.com/images/offersByRequest.jpg"
                            alt="notOffer"
                          />
                        </picture>
                      </LazyLoad>
                    </div>
                  </LinkComponent>
                </div>
                <div className={newCls.offer_team_desc}>
                  <LinkComponent
                    to={eventLink}
                    target={target}
                    className={newCls.unlink}
                  >
                    <p className={newCls.offer_team_desc_amount}>
                      {t('offerBox.moreDetails')}
                    </p>
                  </LinkComponent>
                </div>
              </div>
            </div>
          ))}
      </div>
      {addIvitation ? (
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            onStep5();
            getSlugEvent(event.slug);
            getJoinEvent(true);
          }}
          className={cls.offer_box_invitation_btn}
        >
          {t('create.step8.addInv')}
        </Button>
      ) : (
        ''
      )}
    </div>
  );
}
OfferBox.propTypes = {
  event: PropTypes.shape().isRequired,
  target: PropTypes.string,
  url: PropTypes.string,
  addIvitation: PropTypes.bool,
  sizeBox: PropTypes.bool,
  forMap: PropTypes.bool,
  onStep5: PropTypes.func,
  getSlugEvent: PropTypes.func,
  getJoinEvent: PropTypes.func,
  hidePlaces: PropTypes.bool,
  hidePrices: PropTypes.bool,
  fullScreen: PropTypes.bool,
  noLink: PropTypes.bool,
  showFullTitle: PropTypes.bool,
  limitUser: PropTypes.string,
};

OfferBox.defaultProps = {
  getJoinEvent: () => {},
  getSlugEvent: () => {},
  onStep5: () => {},
  addIvitation: false,
  sizeBox: false,
  forMap: false,
  fullScreen: false,
  target: '_blank',
  hidePlaces: false,
  hidePrices: false,
  noLink: false,
  showFullTitle: false,
  url: '',
  limitUser: '',
};

export default OfferBox;
